/**
 * Reconciliation hooks.
 *
 *   useVariances(status)   list (default 'open' = Joey's working pile)
 *
 * Mutations stay imperative — call api.reconciliation.{create,patch,remove}
 * from a button handler then refetch().
 */
import { useCallback } from 'react';
import { api, type VarianceStatusFilter } from './api';
import { useApiQuery } from './useApiQuery';

export function useVariances(status: VarianceStatusFilter = 'open') {
  const fetcher = useCallback(
    (token: string, signal: AbortSignal) => api.reconciliation.list(token, status, { signal }),
    [status],
  );
  return useApiQuery(fetcher, [status]);
}
